import { createFileRoute } from '@tanstack/react-router'
import Component from "./-components/component"
import { SearchParams } from "@/routes/(pharma)/_layout/reports/supplier-profitability/-data/model"
import { pharmacyClient } from "@/connect";
import { useSupplierProfitabilityData } from './-hooks/useSupplierProfitabilityData';

export const Route = createFileRoute("/(pharma)/_layout/reports/supplier-profitability/")({
  component: Component,
  validateSearch: SearchParams,
});
